import { render, staticRenderFns } from "./offerItem.vue?vue&type=template&id=6f94eb27&"
import script from "./offerItem.vue?vue&type=script&lang=js&"
export * from "./offerItem.vue?vue&type=script&lang=js&"
import style0 from "./offerItem.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f94eb27')) {
      api.createRecord('6f94eb27', component.options)
    } else {
      api.reload('6f94eb27', component.options)
    }
    module.hot.accept("./offerItem.vue?vue&type=template&id=6f94eb27&", function () {
      api.rerender('6f94eb27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/offers/offerItem/offerItem.vue"
export default component.exports